import { brandColors } from '../theme';

/** Card fills grid cell; no fixed minHeight — rows match tallest card in that row only */
export const fillCard = () => ({
  flex: 1,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
});

export const cardBody = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  p: { xs: 2.5, sm: 3 },
  '&:last-child': { pb: { xs: 2.5, sm: 3 } },
};

export const cardTitle = {
  fontWeight: 700,
  mb: 1,
};

export const cardDescription = {
  flex: 1,
  color: 'text.secondary',
};

export const iconBox = {
  width: 52,
  height: 52,
  minWidth: 52,
  minHeight: 52,
  borderRadius: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  bgcolor: brandColors.ice,
  color: brandColors.navy,
  mb: 2,
};

export const previewBox = {
  mt: 'auto',
  minHeight: 120,
  p: 2,
  borderRadius: 2,
  bgcolor: '#fff',
  border: `1px solid ${brandColors.mist}`,
};

export const statCard = {
  flex: 1,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  p: 2.5,
  textAlign: 'center',
  bgcolor: '#fff',
  border: `1px solid ${brandColors.mist}`,
  boxSizing: 'border-box',
};
